import React from "react";

const servicesData = [
  {
    heading: "Personal Statement Writing",
    description:
      "We will write personal statements that are authentic and reflective of who you are. We will also make sure all your personal information is accurate.",
  },
  {
    heading: "Admission Essay Writing",
    description:
      "We write essays that are suitable for top universities. Our writers will produce an essay that will stand out, so you won't have to worry.",
  },
  {
    heading: "College Application Essay",
    description:
      "We also write university application essays for most universities in Canada and the United States. Our team of writers can get you into the university of your dreams.",
  },
  {
    heading: "Motivation Letters (LOM)",
    description:
      "Motivation letters are also known as Letters of Intent. As with the personal statement, the writers of our company will create a statement that is unique to your case.",
  },
  {
    heading: "Recommendation Letters (LOR)",
    description:
      "We can write letters of recommendation on behalf of your professors, colleagues, and associates. All they have to do is simply sign.",
  },
  {
    heading: "Scholarship Essay Writing",
    description:
      "Our scholarship writers can help you write a scholarship essay that documents your knowledge of the field and your contributions. It will help you get into the school of your choice.",
  },
  {
    heading: "Resume Writing Services",
    description:
      "To gain admission or get a job, you must have a resume. Resume development professionals are a part of our team.",
  },
  {
    heading: "Assignment Editing Services",
    description:
      "We can assist you if you need help with your assignments. Our experts will review them and give you advice on how to do better next time.",
  },
];

function Help2() {
  return (
    <section className="layout-section text-center pt-4 pb-0">
      <div className="layout-container">
        <h1 id="heading-large">Our Writing Services</h1>
        <div className="grid md:grid-cols-2 gap-4 mt-8 text-left">
          {servicesData.map((service, index) => (
            <div key={index} className="border rounded-md p-4 bg-white shadow-sm">
              <h2 id="heading-md">{service.heading}</h2>
              <p className="text-gray-600 mt-2">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Help2;
